import { clampLayerFrame } from './clampLayerFrame';
import type { LayerFrame } from './types';

const clamp = (v: number, lo: number, hi: number) => Math.min(hi, Math.max(lo, v));

/** Convert a pointer drag (fractions of the cell) into offset changes so the
 *  zoomed content tracks the pointer 1:1. Inverse of computeReframeTransform:
 *  CSS `scale(s) translate(t%)` applies translate first (in element units),
 *  then scale — so the on-screen shift is t% · s of the cell, i.e.
 *  offset·((s−1)/(2s))·s = offset·(s−1)/2 cell-fractions per unit offset. */
export function applyReframePan(
  { frame, dxFrac, dyFrac }: { frame: LayerFrame; dxFrac: number; dyFrac: number },
): LayerFrame {
  const f = clampLayerFrame(frame);
  if (f.scale <= 1) return f;
  const k = (f.scale - 1) / 2; // on-screen cell-fraction per unit offset
  return {
    scale: f.scale,
    offsetX: clamp(f.offsetX - dxFrac / k, -1, 1),
    offsetY: clamp(f.offsetY - dyFrac / k, -1, 1),
  };
}
